/* SET STATE */
export const SET_STATE_LABREQUESTINCIDENT = "SET_STATE_LABREQUESTINCIDENT"

/* LABREQUESTINCIDENTS */
export const GET_LABREQUESTINCIDENTS = "GET_LABREQUESTINCIDENTS"
export const GET_LABREQUESTINCIDENTS_SUCCESS = "GET_LABREQUESTINCIDENTS_SUCCESS"
export const GET_LABREQUESTINCIDENTS_FAIL = "GET_LABREQUESTINCIDENTS_FAIL"

/* LABREQUESTINCIDENT */
export const GET_LABREQUESTINCIDENT = "GET_LABREQUESTINCIDENT"
export const GET_LABREQUESTINCIDENT_SUCCESS = "GET_LABREQUESTINCIDENT_SUCCESS"
export const GET_LABREQUESTINCIDENT_FAIL = "GET_LABREQUESTINCIDENT_FAIL"

/**
 * ADD LABREQUESTINCIDENT
 */
 export const ADD_NEW_LABREQUESTINCIDENT = "ADD_NEW_LABREQUESTINCIDENT"
 export const ADD_LABREQUESTINCIDENT_SUCCESS = "ADD_LABREQUESTINCIDENT_SUCCESS"
 export const ADD_LABREQUESTINCIDENT_FAIL = "ADD_LABREQUESTINCIDENT_FAIL"

 /**
 * UPDATE LABREQUESTINCIDENT
 */
export const UPDATE_LABREQUESTINCIDENT = "UPDATE_LABREQUESTINCIDENT"
export const UPDATE_LABREQUESTINCIDENT_SUCCESS = "UPDATE_LABREQUESTINCIDENT_SUCCESS"
export const UPDATE_LABREQUESTINCIDENT_FAIL = "UPDATE_LABREQUESTINCIDENT_FAIL"

/**
 * DELETE LABREQUESTINCIDENT
 */
export const DELETE_LABREQUESTINCIDENT = "DELETE_LABREQUESTINCIDENT"
export const DELETE_LABREQUESTINCIDENT_SUCCESS = "DELETE_LABREQUESTINCIDENT_SUCCESS"
export const DELETE_LABREQUESTINCIDENT_FAIL = "DELETE_LABREQUESTINCIDENT_FAIL"
